import React, { type FC } from 'react';
import styles from './RealtorLogo.scss';

interface RealtorLogoProps {
  src: string;
  alt: string;
}

const RealtorLogo: FC<RealtorLogoProps> = ({ src, alt }) => (
  <img
    className={styles['realtor-logo']}
    src={src}
    alt={alt}
    aria-hidden="true"
  />
);

export default RealtorLogo;
